export default __webpack_public_path__ + "static/snaptrip-tp-black-6f9d82fa7139f44aa5f6f63abec9b4b2.svg";